export default [{
    dictKey:'',
    dictValue:'全部'
},{
    dictKey:'0',
    dictValue: '未提交'
},{
    dictKey:'1',
    dictValue: '进行中'
},{
    dictKey:'2',
    dictValue: '进件成功'
},{
    dictKey:'3',
    dictValue: '进件失败'
}];



// WEBPACK FOOTER //
// ./src/service/constant/CardStatus.js